import Modal from 'components/common/modal/modal';

import { useModal, TYPE_MODAL_VIEW } from './context';

import LogoutView from './views/logout-view';
import TermView from './views/term-view';
import RetireView from './views/retire-view';
import PlantView from './views/plant-view';
import SendTabsView from './views/send-view';
import RegisterView from './views/register-view';
import RevokeView from './views/revoke-view';
import DelegateView from './views/delegate-view';
import AccessView from './views/access-view';
import IncreaseStorageView from './views/increase-storage-view';
import WithdrawStorageView from './views/withdraw-storage-view';

function renderModalContent(
  view: TYPE_MODAL_VIEW,
  closeModal: () => void,
  text: string,
  optional: string,
  selected: string[],
  callback: (s) => void
) {
  switch (view) {
    case 'LOGOUT_VIEW':
      return <LogoutView closeModal={closeModal} />;
    case 'TERM_VIEW':
      return <TermView closeModal={closeModal} />;
    case 'REGISTER_VIEW':
      return <RegisterView />;
    case 'RETIRE_VIEW':
      return (
        <RetireView
          closeModal={closeModal}
          text={text}
          recipient={optional}
          callback={callback}
          selected={selected}
        />
      );
    case 'PLANT_VIEW':
      return (
        <PlantView
          closeModal={closeModal}
          text={text}
          callback={callback}
          selected={selected}
        />
      );
    case 'SEND_VIEW':
      return <SendTabsView closeModal={closeModal} />;
    // case 'SEND_VIEW2':
    //   return <SendTabsView closeModal={closeModal} other/>;
    case 'REVOKE_VIEW':
      return <RevokeView closeModal={closeModal} />;
    case 'DELEGATE_VIEW':
      return <DelegateView closeModal={closeModal} />;
    case 'ACCESS_VIEW':
      return <AccessView closeModal={closeModal} />;
    case 'INCREASE_STORAGE':
      return <IncreaseStorageView closeModal={closeModal} />;
    case 'WITHDRAW_STORAGE':
      return <WithdrawStorageView closeModal={closeModal} />;
    default:
      return null;
  }
}

const ModalContainer = () => {
  const { view, text, optional, selected, callback, isOpen, closeModal } =
    useModal();

  return (
    <Modal open={isOpen} view={view} onClose={closeModal}>
      {view &&
        renderModalContent(
          view as TYPE_MODAL_VIEW,
          closeModal,
          text,
          optional,
          selected,
          callback
        )}
    </Modal>
  );
};

export default ModalContainer;
